// @ts-check
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { SPACES } from 'common/constants/sizes';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import noTeams from 'images/no-teams.svg';
import useTeams from 'views/root/views/home/views/settings/views/ContributorsAndTeams/Teams/useTeams';
import useRBACPermissions from 'views/root/views/home/hooks/useRBACPermissions';
import { LBButton } from '@linearb/buzz';

const NoTeamsImgContainer = styled.img`
  ${({ width }) => `width: ${width};`}
  margin-bottom: 1rem;
`;

const TeamsEmptyState = ({
  imageWidth = '32rem',
  textSize = 'large',
  trackingPage = 'DASHBOARD'
}) => {
  const { onConfigureTeam } = useTeams();
  const { isPermitted } = useRBACPermissions();

  return (
    <Flex
      height='100%'
      direction='column'
      items='center'
      content='center'
      justify='center'
    >
      <NoTeamsImgContainer src={noTeams} alt='no teams' width={imageWidth} />
      <Text
        size={textSize}
        pb={SPACES.small}
        pt={SPACES.small}
        color='shuttleGray'
      >
        You don't have any teams yet
      </Text>
      {isPermitted && (
        <LBButton
          size='lg'
          onClick={() => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES[trackingPage],
              page_tab: TRACKING.PAGE_TABS.TEAMS,
              click_type: TRACKING.CLICK.ADD_TEAM
            });
            onConfigureTeam();
          }}
        >
          <Icon color='white' name='Add' /> Add a team
        </LBButton>
      )}
    </Flex>
  );
};

export default TeamsEmptyState;
